import { Box, DashboardModule } from '@domain-group/suit-theme'

import useAssignTemplatePagePermissions from '../../hooks/useAssignTemplatePagePermissionsModal'

import EntityFilters from '../EntityFilters'
import EntityList from '../EntityList'

import TemplateGroup from './TemplateGroup'

interface TemplateGroupsProps {
  assignTemplatePagePermissionsPayload: ReturnType<typeof useAssignTemplatePagePermissions>,
}

const TemplateGroups = (props: TemplateGroupsProps) => {
  const { assignTemplatePagePermissionsPayload } = props

  return (
    <DashboardModule title="Template Groups">
      <Box flexDirection="column" padding="large">
        <EntityFilters
          assignTemplatePagePermissionsPayload={assignTemplatePagePermissionsPayload}
          entityName="Template Groups"
        />

        <EntityList
          assignTemplatePagePermissionsPayload={assignTemplatePagePermissionsPayload}
          entityKey="templateGroupIds"
          // @ts-expect-error TS2322
          entityListItemComponent={TemplateGroup}
        />
      </Box>
    </DashboardModule>
  )
}

export default TemplateGroups
